/**
 * Created by dx.yang on 2017/2/15.
 */

import Vue from 'vue';
import * as commonRegionService from '../../services/common/region';
import * as commonUserInfo from '../../services/common/userInfo';

import * as commonApis from '../../services/apis/common';
import * as constants from './constants';

import KsAjax from 'ksc-vue-ui2/src/services/KsAjax';
import failCallback from '../../services/common/failCallback';
// var uuid = require('ksc-vue-ui2/src/services/uuid');
import uuid from 'ksc-vue-ui2/src/services/uuid'
import mixAction from './mixAction'; //新旧版融合

export default {
    [constants.regionList](ctx) {
        return new Promise((resolve, reject) => {
            ctx.dispatch(constants.unifiedAjax, commonApis.RegionList).then(req => {
                let regionList = req.data;
                regionList = _.map(regionList, (item) => {
                    item.regionNameSrc = item.regionName;
                    item.regionName = ctx.state.regionMapNew(item.regionCode);
                    // item.areaCode = item.regionCode.split('-')[0];
                    // item.areaName = ctx.state.areaMap(item.areaCode);
                    item.isVpc = item.regionCode == 'cn-beijing-5' ? 0 : +item.isVpc;
                    item.areaCode ? '' : item.areaCode = '';
                    return item;
                });

                // let areaList = [];
                // _.forEach(ctx.state.areaSort, (item) => {
                //     let areaRegionList = _.filter(regionList, (subitem) => {
                //         return subitem.areaCode == item;
                //     }) || [];
                //     if (areaRegionList.length) {
                //         //region也需要排序一下
                //         areaRegionList = _.sortBy(areaRegionList, (s) => {
                //             return _.indexOf(ctx.state.regionSortIndex, s.regionCode.toString());
                //         });
                //         areaList.push({
                //             areaCode: item,
                //             areaName: ctx.state.areaMap(item),
                //             regionList: areaRegionList,
                //         });
                //     }
                // });
                // let cloneAreaList = _.cloneDeep(areaList);

                // _.forEach(regionList, (item) => {
                //     item.allAreaList = {
                //         name: ctx.state.areaMap('all'), //'全部区域',
                //         areaList: cloneAreaList
                //     };
                // });

                ctx.commit(constants.regionList, regionList);

                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.RegionInfos](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.RegionInfos);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                ctx.commit(constants.RegionInfos, res);
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.DescribeSnapshotUsageStatus](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.DescribeSnapshotUsageStatus);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.DescribeSnapshotServiceStatus](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.DescribeSnapshotServiceStatus);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.checkSnapShotPermission](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.checkSnapShotPermission);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.openSnapShotService](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.openSnapShotService);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.getDataApi](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.getDataApi);
            ctx.dispatch(constants.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.getDataApiV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.getDataApiV2);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                if(req.status === 0) {
                    let data = {
                        set: params.set,
                        req: req
                    }
                    resolve(data);
                } else {
                    reject(req);
                }
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.checkVncPermission](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.checkVncPermission);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {

                ctx.commit(constants.checkVncPermission, _.get(req, 'isEnabled', false));
                // ctx.commit(constants.checkVncPermission, false) //_.get(req, 'isEnabled', false));
                resolve(req);
                // if (req) {
                //     resolve(req);
                // } else {
                //     reject(req);
                // }
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.unifiedAjax](ctx, data) {
        let Action = _.get(data, 'params.Action', 'unifiedAjax');
        if (!_.get(data, 'options.notAbort', false) && Vue[Action]) Vue[Action].abort();
        let ajaxData = data.params;
        var regionKey = _.get(data, 'params.Region') || ctx.state.regionKey;
        var basic = constants.BasicRegionList(regionKey);
        var isVpc = basic ? 0 : 1;
        data.params.Region = regionKey;
        if (!_.get(data, 'params.BasicRegion', '')) {
            data.params.BasicRegion = basic ? basic : '';
        }
        data.params.isVpc = isVpc;
        data.params.source = 'kec';
        if (data.method === 'post' || data.method === 'put') {
            ajaxData = [
                data.params,
                data.data
            ]
        }
        if (!data.options) {
            data.options = {};
        }
        if (data.options.headers) {
            data.options.headers['X-KSC-REQUEST-ID'] = uuid.create().toString();
        } else {
            data.options.headers = {
                'X-KSC-REQUEST-ID': uuid.create().toString()
            };
        }
        if (!data.method) data.method = 'get';
        let ajaxOptions = data.options;
        // console.log('removeImages', 'ation', 'isvpc', Action, isVpc);
        if (_.isFunction(mixAction[Action]) && (isVpc == 0)) {return mixAction[Action](data);}
        // console.log('removeImages no go to basic');
        return new Promise((resolve, reject) => {
            Vue[Action] = KsAjax[data.method](data.basePath, ajaxData, ajaxOptions);
            Vue[Action].done((res) => {
                if(data.judgeTry) {
                    resolve(res);
                    return;
                }
                if (res && (res.code && res.code == 200 || !res.code)) {
                    resolve(res);
                } else {
                    if(data.params.judgeConfig) {
                        resolve({});
                    } else {
                        if (res.code == '301') {
                            failCallback(null, res.msg || Vue.$trans(`操作失败`));
                        }
                        reject(res.msg || res.Message || res.message || Vue.$trans(`操作失败`));
                    }

                }
            }).fail((c, e) => {
                if(data.judgeTry) {
                    resolve(e);
                    return;
                }
                reject((e.Error && e.Error.Message) || e);
            });
        });

    },
    [constants.DescribeQuotaCount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.DescribeQuotaCount);
            ctx.dispatch(constants.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.DistributeKmsPermission](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.DistributeKmsPermission);
            ctx.dispatch(constants.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.UserListForKPC](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.UserListForKPC);
            ctx.dispatch(constants.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.CheckUserDbscRight](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, commonApis.CheckUserDbscRight);
            ctx.dispatch(constants.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // 未登录

    [constants.noLoginRegionList](ctx) {
        return new Promise((resolve, reject) => {
            ctx.dispatch(constants.unifiedAjax, commonApis.noLoginRegionList).then(req => {
                let regionList = req.data;
                regionList = _.map(regionList, (item) => {
                    item.regionNameSrc = item.regionName;
                    item.regionName = ctx.state.regionMapNew(item.regionCode);
                    // item.areaCode = item.regionCode.split('-')[0];
                    // item.areaName = ctx.state.areaMap(item.areaCode);
                    item.isVpc = item.regionCode == 'cn-beijing-5' ? 0 : +item.isVpc;
                    return item;
                });

                // let areaList = [];
                // _.forEach(ctx.state.areaSort, (item) => {
                //     let areaRegionList = _.filter(regionList, (subitem) => {
                //         return subitem.areaCode == item;
                //     }) || [];
                //     if (areaRegionList.length) {
                //         //region也需要排序一下
                //         areaRegionList = _.sortBy(areaRegionList, (s) => {
                //             return _.indexOf(ctx.state.regionSortIndex, s.regionCode);
                //         });
                //         areaList.push({
                //             areaCode: item,
                //             areaName: ctx.state.areaMap(item),
                //             regionList: areaRegionList,
                //         });
                //     }
                // });
                // let cloneAreaList = _.cloneDeep(areaList);

                // _.forEach(regionList, (item) => {
                //     item.allAreaList = {
                //         name: ctx.state.areaMap('all'), //'全部区域',
                //         areaList: cloneAreaList
                //     };
                // });

                ctx.commit(constants.noLoginRegionList, regionList);

                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
};
